<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save()">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [isEditPage]="false"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <div class="ir-image-preview--wrapper files-plugin maintenance-photo-plugin">
          <div class="ir-stabilizer">
            <div class="ir-image-preview">
              <div class="ir-line ir-plugin-photo th-plugin-photo" *ngFor="let item of allImages; let i = index">
                <div class="ir-line--right photo-buttons">
                  <div class="ir-btn th-btn-normal" (click)="removeItem(item.type, item.index, i)">
                    <i class="material-icons">delete</i>
                  </div>
                  <div class="ir-btn" *ngIf="!inspection.isOffline" (click)="rotateItem(item, i)">
                    <i class="material-icons">rotate_right</i>
                  </div>
                </div>
                <div class="ir-line--left photo-rotate">
                  <div class="ir-plugin-area--photo">
                    <img [rotate]="item.angle" [src]="item.data" />
                  </div>
                </div>
                <div class="ir-line-content-flow"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="!isCameraOn"
          class="ir-image-upload files-plugin"
          dnd
          (filesChangeEmiter)="handleInputChange($event)"
        >
          <div class="drag-and-drop">
            <div class="icon-container">
              <i class="material-icons photo-icon">crop_original</i>
            </div>
            <p>{{ 'plugins.add-photos.copy-and-paste' | translate }}</p>
            <p class="small-text">{{ 'plugins.add-photos.drag-and-drop' | translate }}</p>
          </div>
          <div class="image-upload-divider">
            <div>
              <span>{{ 'plugins.add-photos.or' | translate }}</span>
            </div>
          </div>
          <div class="ir-file-button">
            <div class="ir-inputfile">
              <input
                type="file"
                name="file"
                accept="image/*"
                (click)="clearInput($event)"
                (change)="handleInputChange($event)"
                multiple="true"
                id="file-2"
                capture="camera"
              />
              <label for="file-2" class="ir-btn th-btn-modal">
                <span>{{ 'plugins.add-photos.browse' | translate }}</span>
              </label>
            </div>
          </div>
          <div class="image-upload-divider">
            <div>
              <span>{{ 'plugins.add-photos.or' | translate }}</span>
            </div>
          </div>
          <div class="ir-file-button">
            <div class="ir-inputfile" *ngIf="hasGetUserMedia() && !streaming">
              <label class="ir-btn th-btn-modal turn-on-button" (click)="turnOnCamera()">
                <span>{{ 'plugins.add-photos.turn-camera' | translate }}<i class="material-icons">camera_alt</i></span>
              </label>
            </div>
          </div>
        </div>
        <div [hidden]="!isCameraOn" class="ir-image-upload files-plugin">
          <div class="video-container">
            <div class="ir-line--left">
              <div class="ir-btn th-btn-normal" (click)="closeCamera()">
                <i class="material-icons">arrow_back</i>
              </div>
            </div>
            <video *ngIf="!errorMsg" id="video" class="ir-video-preview"></video>
            <canvas *ngIf="!errorMsg" id="canvas" class="ir-canvas-preview"></canvas>
            <p *ngIf="errorMsg">
              <span>{{ errorMsg }}</span>
            </p>
            <div class="ir-line--right" *ngIf="hasGetUserMedia() && streaming">
              <label
                class="ir-btn th-btn-normal video-button"
                [ngClass]="{ 'th-btn-disabled': !isTorchPossible }"
                (click)="changeFlash()"
              >
                <i *ngIf="!isFlashOn && isTorchPossible" class="material-icons">flash_off</i>
                <i *ngIf="isFlashOn || !isTorchPossible" class="material-icons">flash_on</i>
              </label>
              <label
                class="ir-btn th-btn-normal video-button"
                [ngClass]="{ 'th-btn-disabled': cameras.length < 2 }"
                (click)="switchCamera()"
              >
                <i *ngIf="!isFrontCamera && cameras.length > 1" class="material-icons">camera_rear</i>
                <i *ngIf="isFrontCamera || cameras.length < 2" class="material-icons">camera_front</i>
              </label>
            </div>
            <div class="ir-line--left take-photo-container">
              <label class="ir-btn" (click)="takePicture()">
                <i class="material-icons">camera_alt</i>
              </label>
            </div>
          </div>
        </div>
        <div class="ir-clearfix"></div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid || allImages?.length == 0"
            *ngIf="!processing"
          >
            <span
              >{{ 'plugins.add-photos.start-upload' | translate }} {{ allImages?.length }}
              {{ 'plugins.add-photos.photos' | translate }}</span
            >
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<information
  #errorMessage
  [title]="'plugins.add-photos.error' | translate"
  [message]="'plugins.add-photos.wrong-format' | translate"
  [danger]="true"
></information>
